<app-property-detail [currentAccount]="currentAccount"></app-property-detail>
<div class="actions-bar">
  <div class="row start">
    <button mat-button class="go-back" type="button" (click)="printCertificate()">
      <mat-icon fontIcon="print"></mat-icon>CERTIFICATE OF REGISTRATION</button>
    @if (currentAccount?.rentalProperty?.status == RentalPropertyStatus.ACTIVE){
      <button mat-button class="warn" (click)="inactivateProperty()">
        <mat-icon fontIcon="pause_circle"></mat-icon>INACTIVATE PROPERTY</button>
    } @else {
      <button mat-button class="continue" (click)="reactivatePropery()">
        <mat-icon fontIcon="play_circle"></mat-icon>REACTIVATE PROPERTY</button>
    }
  </div>
  <div class="row end">
    <button class="go-back" type="button" mat-button (click)="onDiscardAndExit()"
    ><mat-icon fontIcon="arrow_back_ios"></mat-icon>GO BACK</button>
    <button class="continue" [disabled]="isLoading" type="submit"
            (click)="save()" mat-button>
      @if (isLoading) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <mat-icon fontIcon="save"></mat-icon>
      }
      SAVE</button>
  </div>
</div>
